module.exports = __webpack_public_path__ + "img/banner-id.9cf284c.jpg";